import script from "./MessagesViewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MessagesViewPage.vue?vue&type=script&setup=true&lang=js"

import "./MessagesViewPage.vue?vue&type=style&index=0&id=29b81e4b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29b81e4b"]])

export default __exports__